import { useState } from 'react'
import {
  Filters,
  FilterSelect,
  useGetMatricesQuery,
  useGetProductsQuery,
  CombinationStatus
} from 'prove-common'

type CombinationsFilterTagsProps = {
  filters: Filters<CombinationStatus>
  setFilters: React.Dispatch<React.SetStateAction<Filters<CombinationStatus>>>
}
const fromNumberId = (arr?: Array<{ id: unknown; name: string }>) =>
  arr?.map(({ id, name }) => ({ id: String(id), name })) ?? []

export const CombinationsFilterTags = ({
  filters,
  setFilters
}: CombinationsFilterTagsProps) => {
  const [currentDialog, setCurrentDialog] = useState<string | undefined>()
  const {
    data: products,
    isPending: isPendingProducts,
    isError: isErrorProducts
  } = useGetProductsQuery(currentDialog === 'products')
  const {
    data: matrices,
    isPending: isPendingMatrices,
    isError: isErrorMatrices
  } = useGetMatricesQuery(currentDialog === 'matrices')
  const productOptions = fromNumberId(products)
  const matrixOptions = fromNumberId(matrices)
  return (
    <>
      <FilterSelect
        name='Produkt'
        options={productOptions}
        selectedIds={filters.productIds ?? []}
        setSelectedIds={(ids) => setFilters({ ...filters, productIds: ids })}
        onOpenChange={(isOpen) =>
          setCurrentDialog(isOpen ? 'products' : undefined)
        }
        isLoading={isPendingProducts}
        isError={isErrorProducts}
        data-cy='filter-product'
      />
      <FilterSelect
        name='Prøve av'
        options={matrixOptions}
        selectedIds={filters.matrixIds ?? []}
        setSelectedIds={(ids) => setFilters({ ...filters, matrixIds: ids })}
        onOpenChange={(isOpen) =>
          setCurrentDialog(isOpen ? 'matrices' : undefined)
        }
        isLoading={isPendingMatrices}
        isError={isErrorMatrices}
        data-cy='filter-matrix'
      />
    </>
  )
}
